const defaultState = {
  name: '',
  nameForClient: '',
  position: '',
  portionDivision: 1,
};

export default defaultState;
